import React from 'react'

const Cross = () => (
  <svg width="12" height="12" viewBox="0 0 1000 1000">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M585.8 500l385.9-385.9c24.5-24.5 24.5-61.3 0-85.8s-61.3-24.5-85.8 0L500 414.3 114.1 28.4c-24.5-24.5-61.2-24.5-85.8 0-24.5 24.5-24.5 61.3 0 85.8L411.2 500 28.4 885.9c-24.5 24.5-24.5 61.3 0 85.8 9.2 12.3 27.6 18.4 42.9 18.4 15.3 0 30.6-6.1 42.9-18.4L500 585.8l385.9 385.9c12.3 12.3 27.6 18.4 42.9 18.4s30.6-6.1 42.9-18.4c24.5-24.5 24.5-61.3 0-85.8L585.8 500z"
      fill="#a2a2a2"
    />
  </svg>
)

export default Cross
